import { render, staticRenderFns } from "./UserCenterLayout.vue?vue&type=template&id=7acd2805&scoped=true"
import script from "./UserCenterLayout.vue?vue&type=script&lang=js"
export * from "./UserCenterLayout.vue?vue&type=script&lang=js"
import style0 from "./UserCenterLayout.vue?vue&type=style&index=0&id=7acd2805&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acd2805",
  null
  
)

export default component.exports